import styled from '@emotion/styled';
import { forwardRef, PropsWithChildren } from 'react';

import { BoxProps } from 'app/components/v2/components/Box';

// Local Typings
interface ContentProps {
  contentRef?: React.Ref<HTMLDivElement>;
  height?: string;
  maxWidth?: BoxProps['maxWidth'];
  scroll?: boolean;
}
interface WrapperProps {
  height?: string;
  padding?: string;
  ref?: React.Ref<HTMLDivElement>;
  shouldGrowWrapper?: boolean;
}
export type ContainerProps = ContentProps & WrapperProps;

// Local Variables
const Content = styled.div<ContentProps>(props => ({
  height: props.height ?? 'auto',
  margin: '0 auto',
  maxWidth: props.maxWidth ?? 1280,
}));
const Wrapper = styled.div<WrapperProps>(props => ({
  height: props.height ?? 'auto',
  padding: `0 ${props.padding ?? '10px'}`,
  width: props.shouldGrowWrapper ? '100%' : 'auto',
}));

const Container = forwardRef<HTMLDivElement, PropsWithChildren<ContainerProps>>(({
  contentRef,
  ...props
},
ref) => (
  <Wrapper
    height={props.height}
    padding={props.padding}
    {...props}
    ref={ref}
  >
    <Content
      height={props.height}
      maxWidth={props.maxWidth}
      ref={contentRef}
    >
      {props.children}
    </Content>
  </Wrapper>
));

export default Container;
